import React, {useState, useEffect} from "react";
import ListNotices from "./bits/listNotices/listNotices";
import {useHistory} from "react-router";
import {useStores} from "../../stores/useStores";
import withRedirectWithoutASelectedVillage from "../../utils/auth/withRedirectWithoutASelectedVillage";
import {RoutePaths} from "../../shared/routePaths";
import {observer} from "mobx-react-lite";

export enum NoticeBits {
  List
}

// No great way to test setActiveBit
/* istanbul ignore file */

const Notices: React.FC = () => {
  const [activeBit, setActiveBit] = useState(NoticeBits.List);
  const {
    uiStore: {noticesUiStore},
    uiStore
  } = useStores();

  useEffect(() => {
    return () => {
      noticesUiStore.resetIsCreatingOrEditingFlag();
      noticesUiStore.resetIsViewingNoticeFlag();
    };
  }, [noticesUiStore]);

  useHistory().listen(() => {
    const isStillOnNoticesPage = history.location.pathname.includes(
      RoutePaths.Notices
    );
    // This will run when the user is on any other page other than notices page,
    //   and will reset pagination settings
    if (!isStillOnNoticesPage) {
      noticesUiStore.resetPaginationSettings();
    }

    //Any time navigation happens in the app reset view
    setActiveBit(NoticeBits.List);
  });

  const history = useHistory();

  const getActiveBit = () => {
    switch (activeBit) {
      case NoticeBits.List:
        return (
          <ListNotices
            switchToEditNotice={async (noticeId?: string) => {
              history.push(
                `${RoutePaths.Notices}/edit/${noticeId}?villageId=${uiStore.selectableVillages?.selectedItem?.value}`
              );
            }}
            switchToAddNotice={() =>
              history.push(
                `${RoutePaths.CreateNotice}?villageId=${uiStore.selectableVillages?.selectedItem?.value}`
              )
            }
            switchToViewNotice={(noticeId?: string) =>
              history.push(
                `${RoutePaths.Notices}/view/${noticeId}?villageId=${uiStore.selectableVillages?.selectedItem?.value}`
              )
            }
          />
        );
    }
  };

  return getActiveBit();
};

export default withRedirectWithoutASelectedVillage(observer(Notices));
